import React, { useState } from "react";
import "./mainContent.css";
import DocumentView from "../documentView/documentView";
import CompanyTabs from "../companyTabs/companyTabs";
import SectorTabs from "../sectorTabs/sectorTabs";
const MainContent = ({ search, category }) => {
    const highlights = [
        {
            id: 1,
            name: "ESG Goal Jan 2024",
            text: "Focus on sustainability goals for 2024.",
            pdfUrl: "https://link-logic-documents.s3.ap-south-1.amazonaws.com/zomato/main/sustainability/esg_goals_Jan2024.pdf",
            pageNumber: 4,
            areas: [
                {
                    left: 321.3770751953125,
                    top: 236.91822814941406,
                    width: 534.7450561523438 - 321.3770751953125,
                    height: 247.5182342529297 - 236.91822814941406,
                },
                {
                    left: 321.3770751953125,
                    top: 247.91822814941406,
                    width: 364.2731018066406 - 321.3770751953125,
                    height: 258.5182189941406 - 247.91822814941406,
                },
            ],
        },
        {
            id: 3,
            name: "Earnings Call Transcript",
            text: "Future earnings call transcript and outlook.",
            pdfUrl: "https://link-logic-documents.s3.ap-south-1.amazonaws.com/zomato/main/earnings_call/Earnings_call_transcript_Q1_FY25.pdf",
            pageNumber: 2,
            areas: [
                {
                    left: 100.5,
                    top: 200.5,
                    width: 300.5 - 100.5,
                    height: 220.5 - 200.5,
                },
            ],
        },
        {
            id: 2,
            name: "ESG Goal Jan 2024",
            text: "Detailed metrics for ESG performance.",
            pdfUrl: "https://link-logic-documents.s3.ap-south-1.amazonaws.com/zomato/main/sustainability/esg_goals_Jan2024.pdf",
            pageNumber: 2,
            areas: [
                {
                    left: 321.3770751953125,
                    top: 247.91822814941406,
                    width: 364.2731018066406 - 321.3770751953125,
                    height: 258.5182189941406 - 247.91822814941406,
                },
            ],
        },

    ];

    console.log(search);

    const [selectedHighlight, setSelectedHighlight] = useState(highlights[0]);

    return (
        <div>
            {category === "Document" && (
                <div style={{ display: "flex", height: "90vh" }}>
                    {/* Sidebar with highlights list */}
                    <div
                        style={{
                            width: "20%",
                            backgroundColor: "#f7f7f7",
                            padding: "1rem",
                            overflowY: "auto",
                        }}
                    >
                        <h3>Highlights</h3>
                        <ul style={{ listStyleType: "none", padding: 0 }}>
                            {highlights.map((highlight) => (
                                <li
                                    key={highlight.id}
                                    style={{
                                        marginBottom: "1rem",
                                        cursor: "pointer",
                                        padding: "0.5rem",
                                        backgroundColor:
                                            selectedHighlight.id === highlight.id
                                                ? "#e0e0e0"
                                                : "transparent",
                                        borderRadius: "4px",
                                    }}
                                    onClick={() => setSelectedHighlight(highlight)}
                                >
                                    <p style={{ margin: 0, fontWeight: "bold" }}>
                                        {highlight.text}
                                    </p>
                                    <small style={{ color: "#555" }}>{highlight.name} - Page {highlight.pageNumber}</small>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Document view */}
                    <div style={{ width: "70%", height: "100%", overflow: "auto" }}>
                        <DocumentView
                            pdfUrl={selectedHighlight.pdfUrl}
                            pageNumber={selectedHighlight.pageNumber}
                            highlightAreas={selectedHighlight.areas}
                        />
                    </div>
                </div>)}

            {category === "Company" && (
                <div>
                    <CompanyTabs name={search} />
                </div>
            )}

            {category === "Sector" && (
                <div>
                    <SectorTabs name={search} />
                </div>
            )}
        </div>
    );
};

export default MainContent;
